module.exports = __webpack_public_path__ + "static/media/25_B.085a2650.png";